import type { ProgressStatus } from '../services/assignmentService';

/**
 * The deadline has passed. Assignments carry a date *and* a time, so this compares full
 * timestamps; rounding both sides to a calendar day would keep an assignment due at 14:30
 * "not late" until midnight. Answers false when there is no due date.
 */
export function isPastDue(iso?: string | null): boolean {
  return iso ? new Date(iso).getTime() < Date.now() : false;
}

/**
 * Past due and not yet completed by this user — the assignments that can no longer be
 * started. A completed one stays reviewable. The backend applies the same rule when a
 * session is created (`AssignmentCRUD.is_overdue_for_user`), so keep the two in step.
 */
export function isOverdueUnfinished(iso: string | null | undefined, status: ProgressStatus | null | undefined): boolean {
  return status !== 'completed' && isPastDue(iso);
}
